import React from 'react';
import PropTypes from 'prop-types';
import styles from './CellTypes.module.less';
import validationInactive from '../../../../../../../static/img/validation-grey.svg';
import validationEmpty from '../../../../../../../static/img/validation-empty.svg';
import validation from '../../../../../../../static/img/validation.svg';
import { StatusFilterMapper } from '../../../constants';

function CheckBoxCell({ cell: { value }, row: { original: initialRow } }) {
  return (
    <div className={styles.checkbox}>
      <img
        className={styles.validationMark}
        src={
          value
            ? initialRow.status.type !== StatusFilterMapper.ACTIVE
              ? validationInactive
              : validation
            : validationEmpty
        }
        alt=""
        id={
          value
            ? initialRow.status.type !== StatusFilterMapper.ACTIVE
              ? 'grey-checkbox'
              : 'green-checkbox-checkbox'
            : 'empty-checkbox-checkbox'
        }
      />
    </div>
  );
}

CheckBoxCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
};

export default CheckBoxCell;
